define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/view",
	"csi/action/Controller",
	"csi/widget/MessageDialog"
], function(declare, _, csiView, Controller, MessageDialog) {

	return declare(Controller, {
		postProcessSuccess: function() {
			// summary: refresh table views and properties view
			var v = csiView.getView("Properties");
			if (v) {
				v.refreshData();
			}

			_.each(csiView.getAllViews("HierarchicalPartMaterials"), function(v) {
				v.refreshData();
			});

			_.each(csiView.getAllViews("PartMaterials"), function(v) {
				v.refreshData();
			});
		}
	});
});